import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from './ui/card';
import { 
  Heart, 
  Scissors, 
  ShoppingBag, 
  Award, 
  Star, 
  AlertTriangle, 
  Phone,
  Info
} from 'lucide-react';

export const PageCards = () => {
  const pages = [
    {
      title: 'About Us',
      description: 'Learn about our journey since 1995 and our commitment to providing exceptional canine care with experienced professionals.',
      icon: Info,
      path: '/about',
      color: 'bg-blue-50 hover:bg-blue-100',
      iconColor: 'text-blue-600',
      backgroundImage: '/images/image11.jpeg' // Add your image path here, e.g., '/images/about-bg.jpg'
    },
    {
      title: 'Our Services',
      description: 'Discover our comprehensive range of veterinary and pet care services including checkups, vaccinations, surgery, and more.',
      icon: Heart,
      path: '/services',
      color: 'bg-green-50 hover:bg-green-100',
      iconColor: 'text-green-600',
      backgroundImage: '/images/vetservice.jpg' // Add your image path here
    },
    {
      title: 'Grooming',
      description: 'Professional grooming services to keep your canine companion looking and feeling their best with expert care.',
      icon: Scissors,
      path: '/grooming',
      color: 'bg-purple-50 hover:bg-purple-100',
      iconColor: 'text-purple-600',
      backgroundImage: '/images/vetgroom.jpg' // Add your image path here
    },
    {
      title: 'Shop',
      description: 'Browse our selection of quality pet products, food, accessories, and supplies for your furry friend.',
      icon: ShoppingBag,
      path: '/shop',
      color: 'bg-orange-50 hover:bg-orange-100',
      iconColor: 'text-orange-600',
      backgroundImage: '/images/image13.jpeg' // Add your image path here
    },
    {
      title: 'Why Choose Us',
      description: 'Find out what makes Raj Canine Care the trusted choice for pet owners and why families keep coming back.',
      icon: Award,
      path: '/why-us',
      color: 'bg-yellow-50 hover:bg-yellow-100',
      iconColor: 'text-yellow-600',
      backgroundImage: '/images/image2.jpeg' // Add your image path here
    },
    {
      title: 'Customer Reviews',
      description: 'Read what our happy customers say about their experiences with our services and see our Google reviews.',
      icon: Star,
      path: '/reviews',
      color: 'bg-pink-50 hover:bg-pink-100',
      iconColor: 'text-pink-600',
      backgroundImage: '/images/vetcustomer.jpg' // Add your image path here
    },
    {
      title: 'Warning Signs',
      description: 'Learn to identify critical health warning signs in your dog that require immediate veterinary attention.',
      icon: AlertTriangle,
      path: '/warning-signs',
      color: 'bg-red-50 hover:bg-red-100',
      iconColor: 'text-red-600',
      backgroundImage: '/images/image12.jpeg' // Add your image path here
    },
    {
      title: 'Contact Us',
      description: 'Get in touch with us for appointments, inquiries, or emergency care. We\'re here to help your pet.',
      icon: Phone,
      path: '/contact',
      color: 'bg-indigo-50 hover:bg-indigo-100',
      iconColor: 'text-indigo-600',
      backgroundImage: '/images/image1.jpeg' // Add your image path here
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Explore Our Services
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discover everything we offer at Raj Canine Care - from veterinary services to grooming and expert advice
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pages.map((page, index) => {
            const Icon = page.icon;
            return (
              <Card 
                key={index} 
                className={`relative overflow-hidden transition-all duration-300 hover:shadow-xl hover:-translate-y-1 ${page.color} border-none`}
                style={page.backgroundImage ? {
                  backgroundImage: `url('${page.backgroundImage}')`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                } : {}}
              >
                {/* Overlay for text readability when background image is present */}
                {page.backgroundImage && (
                  <div className="absolute inset-0 bg-white/70"></div>
                )}
                
                <div className="relative z-10">
                  <CardHeader>
                    <div className={`w-12 h-12 rounded-lg bg-white flex items-center justify-center mb-3 shadow-sm`}>
                      <Icon className={`w-6 h-6 ${page.iconColor}`} />
                    </div>
                    <CardTitle className="text-xl font-bold text-gray-900">
                      {page.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent>
                    <CardDescription className="text-black text-sm leading-relaxed">
                      {page.description}
                    </CardDescription>
                  </CardContent>
                  <CardFooter>
                    <Link to={page.path} className="w-full">
                      <Button 
                        className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white shadow-md"
                      >
                        Learn More
                      </Button>
                    </Link>
                  </CardFooter>
                </div>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
